import { useMenuData } from "../offline/menuData"
import { formatAsOf } from "../models/syncStatus"
import "./StaleBanner.css"

// Shown once the last successful sync is more than a day old.
export default function StaleBanner() {
  const { isStale, isOnline, sync } = useMenuData()
  if (!isStale) return null

  return (
    <p className="stale-banner t-p12" role="status">
      Menu last updated {formatAsOf(sync.lastSyncedAt)}.{" "}
      {isOnline ? "Tap the sync status to refresh." : "Connect to refresh."}
    </p>
  )
}

// Dates allergen information that may be out of date.
export function AsOfNote({ className = "" }) {
  const { isStale, sync } = useMenuData()
  if (!isStale) return null

  return (
    <span className={`as-of ${className}`.trim()}>As of {formatAsOf(sync.lastSyncedAt)}</span>
  )
}
